import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import './index.scss';
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux";
import { useGetSearchQueryQuery, useGetStoreQuerySearchQueryQuery } from '../../services/search';
import Skeleton from '@material-ui/lab/Skeleton';
import { addProductImg } from "../../Reducers/authReducer";
import Loader from '../../Components/Loader';
import Button from '@mui/joy/Button';
import { useMediaQuery } from 'react-responsive'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import SearchLoader from '../../Components/SearchLoader';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import { makeStyles } from '@material-ui/core/styles';
import { useGetUserDataQuery } from '../../services/login';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import formatPrice from '../../Components/formatPrice';
import IconButton from '@mui/joy/IconButton';
import ProductCountries from '../../Components/Header/ProductCountries';
import { notification, Tag } from 'antd';
import "antd/dist/antd.min.css";
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import SeacrhFilter from '../../Components/SeacrhFilter';
import GetFilterCountries from '../../Components/GetFilterCountries';
import SearchAdBanner from '../../Components/SearchAdBanner';
import LoadMoreSkeleton from '../../Components/LoadMoreSkeleton';
import { Helmet } from 'react-helmet';
import Host from '../../Components/Host';
var moment = require('moment');
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  item: {
    scrollSnapAlign: 'start',
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none"
    }, /* Chrome */
    scrollSnapType: 'x mandatory',
    flexWrap: 'nowrap',
    margin: '0px !important',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

function Pricing() {
  const { userId, userToken, userEmail, languageCode, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { query } = useParams();
  const limit = new URLSearchParams(location.search).get('size') || 48
  const searchCountry = new URLSearchParams(location.search).get('country') || null
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : ''
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })
  const isMobcreen2 = useMediaQuery({ query: '(min-width: 0px) and (max-width: 992px)' })
  const isMobcreenA = useMediaQuery({ query: '(min-width: 768px) and (max-width: 1240px)' })
  const { data: userData } = useGetUserDataQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);

  const { data: newPosts = [], isLoading, error, isError, isFetching, originalArgs } = useGetSearchQueryQuery({
    page: getPage,
    size: limit,
    query: query,
    search_id: `&search_id=${getSearchId}`,
    countryCode: countryCode,
    searchCountry: thisCountry
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const products = newPosts?.results

  React.useEffect(() => {
    if (products?.length > 0) {
      setProductsData((prevPosts) => [...prevPosts, ...products]);
    }
  }, [newPosts]);

  useEffect(() => {
    if (products) {
      setProductsData(() => [...products]);
      setPage(1)
    }
  }, [query, searchCountry]);


  useEffect(() => {
    if (Number(getPage) === 1 && products) {
      setProductsData((prevPosts) => [...products]);
    }
  }, [getPage, products]);


  useEffect(() => {
    if (Number(getPage) === 1 && isFetching) {
      setProductsData((prevPosts) => []);
    }
  }, [getPage, query, searchCountry]);


  const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchId(lastId)
  };

  const { data: localData, isLoading: localLoading, isError: localError, isFetching: localFetching } = useGetStoreQuerySearchQueryQuery({
    page: 1,
    size: 15,
    query: query,
    countryCode: countryCode
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const localSearchData = localData?.results

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }

  function addProductImage(data) {
    dispatch(addProductImg({ productImg: data }));
  }

  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }

  const classes = useStyles();
  function loadFetch() {
    if (isLoading) {
      return true
    } else if (isFetching) {
      return true
    } else {
      return false
    }
  }

  function localLoadFetch() {
    if (localLoading) {
      return true
    } else if (localFetching) {
      return true
    } else {
      return false
    }
  }

  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0)
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return <>{t('delivery_by')} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), 'days').format('Do')}</>
      } else {
        return <>{t('delivery_by')} {moment().add(Number(deliveryDaya), 'days').format('Do MMM')}</>
      }
    }
    if (Number(deliveryDaya) > 0) {
      return getTimeline()
    } else {
      return `${t('delivery_by')} ${moment().add(10, 'days').format('Do MMM')}`
    }
  }


  const soteIds = [3, 1]

  function functionIdLink(id, pid, store_id) {
    if (soteIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }

  const listRef = React.useRef(null);
  const handleScroll = (direction) => {
    if (listRef.current) {
      const itemWidth = listRef.current.scrollWidth / localSearchData?.length;
      listRef.current.scrollBy({
        left: direction === 'next' ? itemWidth * 4 : -itemWidth * 4,
        behavior: 'smooth',
      });
    }
  };

  const [api, contextHolder] = notification.useNotification();
  React.useEffect(() => {
    if (error?.originalStatus === 429) {
      api['error']({
        message: error?.data,
        showProgress: true,
        pauseOnHover: false,
        duration: 5,
        placement: 'top'
      });
    }
  }, [error]);



  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${query ? query : ''} ${query && '|'} ${Host?.metaTitle}`}</title>
      </Helmet>
      {contextHolder}
      <div className="sp-style">
        <div className="search-section" style={{ position: 'relative' }}>

          <div className="container">
            <div className="row">

              {!isMobcreen2 &&
                <SeacrhFilter searchCountry={searchCountry} getProducts={getProducts} isFetching={isFetching} />
              }

              <div className="col-md-10 mob-w100 mob-p0" style={{ padding: '5px' }}>
                <div className="row">

                  {/* <div className="col-md-12" style={{ padding: '5px' }}>
                    <SearchAdBanner />
                  </div> */}


                  {isMobcreen2 &&
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <div>
                        <GetFilterCountries searchCountry={searchCountry} />
                      </div>
                    </div>
                  }

                  {isLoading &&
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <div className='sp-search-loader'>
                        <div
                          className='sp-query'
                          style={{ fontSize: '1rem', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                          <span style={{ display: 'flex', alignItems: 'center' }}>
                            <i className='loader-title'>{t('Searching For') + '  ' + query}</i></span>&nbsp;
                          <SearchLoader />
                        </div>

                      </div>
                    </div>
                  }


                  {localSearchData?.length > 0 &&
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                        <div style={{ padding: '10px 5px 0px 5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                              <BoltOutlinedIcon style={{ color: '#fe7f4a', fontSize: '1.4rem' }} />{t('Fastest Delivery Options')}</span>
                            <Button
                              className="mobile-hide"
                              component={Link}
                              to={`/store/query/${query}`}
                              size='sm' variant='outlined' style={{ textTransform: 'capitalize', minHeight: '25px' }}>
                              <small>{t('view_store')}</small>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  {localLoadFetch() ?
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <ImageList
                        style={{ width: '100%', marginTop: '10px', marginBottom: '10px', margin: 0 }}
                        className={classes.imageList}
                        cols={isMobcreen ? 1.2 : 3}>
                        {Array(4).fill().map((_, index) => (
                          <ImageListItem key={index} className="cardItem" style={{ maxWidth: 'none', flex: 'none', height: 'auto', position: 'relative', padding: '5px' }}>
                            <div
                              style={{ flexDirection: 'row', alignItems: 'center' }}
                              className="cardItem-item local-store-card-item"
                            >
                              <div className="img-card imgCard lcl-store-carousel-card" style={{ width: '45%', maxWidth: '45%', minWidth: '45%' }}>
                                <Skeleton className="img-item skeleton lcl-store-carousel-img" variant="rect" />
                              </div>
                              <div className="card-content" style={{ width: '55%', maxWidth: '55%', minWidth: '55%' }}>
                                <div className='title-card' style={{ minHeight: 'auto', maxHeight: 'auto' }}>
                                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '100%', marginTop: '5px' }} />
                                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '75%', marginTop: '5px' }} />
                                </div>
                                <div className="content-item" style={{ padding: '5px 0px' }}>
                                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '80%', marginTop: '5px' }} />
                                </div>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '40%', marginTop: '5px' }} />
                                </div>
                              </div>
                            </div>
                          </ImageListItem>
                        ))}
                      </ImageList>
                    </div>
                    :
                    <>
                      {localSearchData?.length > 0 &&
                        <div className="col-md-12" style={{ padding: '5px' }}>
                          <div style={{ position: 'relative' }}>
                            {localSearchData?.length > 5 &&
                              <>
                                <div className='scroll-back_cards-search'>
                                  <IconButton
                                    style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                                    variant='outlined'
                                    size='sm'
                                    onClick={() => handleScroll('prev')}
                                    disabled={false}>
                                    <svg width="17" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                    </svg>
                                  </IconButton>
                                </div>
                                <div className='scroll-next_cards-search'>
                                  <IconButton
                                    style={{ display: 'flex', alignItems: 'center', background: '#fcfcfc', borderRadius: '100px' }}
                                    variant='outlined'
                                    size='sm'
                                    onClick={() => handleScroll('next')}
                                    disabled={false}>
                                    <svg width="17" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                                      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                  </IconButton>
                                </div>
                              </>
                            }
                            <ImageList
                              ref={listRef}
                              style={{ margin: 0, position: 'relative' }}
                              className={classes.imageList}
                              cols={isMobcreenA ? 2.5 : isMobcreen ? 1.02 : 3.3}>
                              {localSearchData?.map((item, i) =>
                                <ImageListItem className="cardItem fd-carousel" key={i} style={{ maxWidth: 'none', flex: 'none', height: 'auto', position: 'relative', padding: '5px' }}>
                                  <Link
                                    style={{ flexDirection: 'row', alignItems: 'center' }}
                                    className="cardItem-item local-store-card-item"
                                    onClick={(() => addProductImage(item?.image))}
                                    to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>
                                    <div className="img-card imgCard lcl-store-carousel-card" style={{ width: '45%', maxWidth: '45%', minWidth: '45%' }}>
                                      <LazyLoadImage
                                        delayTime={100}
                                        key={i}
                                        alt={item?.title}
                                        effect="blur"
                                        className="img-item lcl-store-carousel-img"
                                        src={item?.image}
                                        onError={handleError}
                                        beforeLoad={beforeLoadHandler}
                                      />
                                    </div>
                                    <div className="card-content" style={{ width: '55%', maxWidth: '55%', minWidth: '55%' }}>
                                      <div className='title-card' style={{ minHeight: 'auto', maxHeight: 'auto' }}>
                                        <h4 style={{ fontSize: '12px' }}>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                          {item?.brand && <div className='brand'>{item?.brand}</div>}
                                          {ratingFucn(item?.rating) &&
                                            <div className='rating' style={{ display: 'flex', alignItems: 'center' }}>
                                              <span style={{ display: 'flex', alignItems: 'center', color: '#a8a8a8', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                                              <GradeIcon style={{ color: '#fe7f4a', fontSize: '1rem', marginTop: '-1.5px' }} />
                                            </div>
                                          }
                                        </div>
                                      </div>
                                      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                        <div className="content-item" style={{ padding: '5px 0px' }}>
                                          <h5 style={{ fontSize: '14px' }}>
                                            {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}
                                            {item?.prices?.deal_value &&
                                              <small style={{ color: '#fe7f4a', margin: '0px 5px' }}>
                                                <small style={{ textDecoration: 'line-through', }}>{item?.prices?.price}</small> 50% Off
                                              </small>
                                            }
                                          </h5>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <div style={{ fontSize: '12px', lineHeight: 0, color: '#444' }}>From</div>
                                          <img
                                            style={{ width: '20px', objectFit: 'contain', margin: '0 5px' }}
                                            loading="lazy"
                                            src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                                            srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                                            alt=""
                                          />
                                          <div style={{ fontSize: '12px', lineHeight: 0, color: '#444' }}>{ProductCountries(item?.country)}</div>
                                        </div>
                                      </div>
                                      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                        <div
                                          style={{ position: 'relative', right: '0px', bottom: 0, color: '#000', fontSize: '12px', lineHeight: 1, borderRadius: '2px' }}><small><i>{getDeliverydays(item.estimated_delivery)}</i></small>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                </ImageListItem>
                              )}
                            </ImageList>
                          </div>
                        </div>
                      }
                    </>
                  }


                  {!isLoading &&
                    <div style={{ width: '100%', padding: '10px 0px 10px 0px' }}>
                      <div className='search-cardTitle' style={{ textAlign: 'start' }}>
                        <div className='search-result-secton'>
                          <div className='sp-query' style={{ width: '100%' }}>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                              <span className='loader-title'>Search results for:&nbsp; {query}</span> &nbsp;
                              {loadFetch() && <span><SearchLoader /></span>}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  {!isLoading &&
                    <>
                      {!isFetching &&
                        <>
                          {getProducts?.length === 0 &&
                            <div className='no-result-found-secton'>
                              <ErrorOutlineOutlinedIcon />
                              <div className='cardTitle'>Looks like we couldn't find what you're searching for.</div>
                            </div>
                          }
                        </>
                      }
                    </>
                  }

                  <>
                    {getProducts?.map((item, i) => item?.pid ?
                      <div className="col-md-3 cardItem" style={{ padding: '5px' }} key={i}>
                        <Link
                          className="cardItem-item"
                          onClick={(() => addProductImage(item?.image))}
                          to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}>
                          <div className="img-card imgCard">
                            <LazyLoadImage
                              delayTime={100}
                              key={i}
                              alt={item?.title}
                              effect="blur"
                              className="img-item"
                              src={item?.image}
                              onError={handleError}
                              beforeLoad={beforeLoadHandler}
                            />

                            <div className={`delivery-days`}>
                              <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
                                {getDeliverydays(item.estimated_delivery)}
                              </span>
                            </div>

                          </div>
                          <div className="card-content">
                            <div className='title-card' style={{ maxHeight: '45px', minHeight: '45px' }}>
                              <h4>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 1 }}>
                              {item?.brand && <div className='brand' style={{ width: '100%' }}>{item?.brand}</div>}
                              {ratingFucn(item?.rating) &&
                                <div className='rating' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                                  <span style={{ display: 'flex', alignItems: 'center', color: '#575959', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                                  <GradeIcon style={{ color: '#fe7f4a', fontSize: '1rem', marginTop: '-1.5px' }} />
                                </div>
                              }
                            </div>
                            <div className="content-item" style={{ padding: 0 }}>
                              {isFetching ? <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '30%' }} /> :
                                <div className='item-price-card' style={{ alignItems: 'flex-end' }}>
                                  {Number(item?.prices?.value) === 0 ?
                                    <span className='badge badge-secondary'>Check Price</span>
                                    :
                                    <>
                                      <span className='item-deal-price'>
                                        <div style={{ lineHeight: 1.2 }}>
                                          <span style={{ fontSize: '12px', fontWeight: 300, color: '#575959' }}>Est. Price</span><br />
                                          {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}&nbsp;
                                        </div>
                                      </span>
                                      {item?.prices?.deal_value &&
                                        <span className='item-price' style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                          <small style={{ textDecoration: 'line-through', color: '#828282' }}>
                                            {formatPrice(item?.prices?.price, item?.prices?.currency, 0)}
                                          </small>&nbsp;
                                          {item?.prices?.discount ?
                                            <span className='badge badge-danger'>
                                              {`-${item?.prices?.discount}%`}
                                            </span> : ``
                                          }
                                        </span>
                                      }
                                    </>
                                  }
                                </div>
                              }
                            </div>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                              <span style={{ fontSize: '11px', fontWeight: 400, color: '#575959' }}>{`(Check Final Price)`}</span>

                              {isFetching ? <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '30%' }} /> :
                                <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', lineHeight: 0, color: '#575959' }}>
                                  {t('From')}&nbsp;
                                  <img
                                    style={{ width: '20px', objectFit: 'contain' }}
                                    loading="lazy"
                                    src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                                    srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                                    alt=""
                                  />&nbsp;
                                  <div style={{ fontSize: '12px', lineHeight: 0, color: '#575959' }}>{ProductCountries(item?.country)}</div>
                                </div>
                              }
                            </div>
                          </div>
                        </Link>
                      </div> : ''
                    )}
                  </>
                  {loadFetch() &&
                    <LoadMoreSkeleton />
                  }
                </div>
                <br />
              </div>

              {getProducts?.length > 0 &&
                <div className='search-paginattion' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <Button
                      style={{ border: '0.5px solid #39414a', color: '#39414a', fontWeight: 400, height: '40px', margin: '0px 10px' }}
                      disabled={isFetching}
                      variant='outlined'
                      onClick={loadMore}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{loadFetch() ? 'Loading' : t('load_more')}</span>
                        {loadFetch() && <span style={{ margin: '0px 10px' }}><Loader /></span>}
                      </div>
                    </Button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <br /><br />
      </div>
    </>
  );
}

export default Pricing;
